var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"segmented-progress mx-5 mb-2",attrs:{"no-gutters":""}},_vm._l((_vm.progressArray),function(value,index){return _c('v-col',{key:index,class:[
      'segment',
      value === 1 ? 'filled' : '',
      index === 0 ? 'first' : '',
      index === _vm.progressArray.length - 1 ? 'last' : '',
      _vm.isStartOfFilled(index) ? 'start-filled' : '',
      _vm.isEndOfFilled(index) ? 'end-filled' : ''
    ],style:({backgroundColor: value === 1 ? ("var(" + _vm.filledColor + ")") : _vm.emptyColor})})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }